export default __webpack_public_path__ + "static/silpo-cc9bec2f6b03eb1901a9f33774b5b019.svg";